import { render, staticRenderFns } from "./AddSegmentModal.vue?vue&type=template&id=18451303&"
import script from "./AddSegmentModal.vue?vue&type=script&lang=js&"
export * from "./AddSegmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports